import { apiGet } from './index'

export function getLaacPageList2(params) {
  return apiGet('/api/laac/h5/page2', params)
}

export function getLaacCategoryTree(params) {
  return apiGet('/api/course/categories/tree/framework/laac', params)
}

export function getLaacHotRecommend(params) {
  return apiGet('/api/laac/h5/recommend', params)
}



// WEBPACK FOOTER //
// ./src/api/laac.js